export class Retorno {
  sucesso: boolean;
  erro: string;
  tokens: string[];
}
